"use client";
import * as React from "react";
const SvgAddOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 7v5h2V7h5V5H7V0H5v5H0v2z", clipRule: "evenodd" }));
export {
  SvgAddOutlined as default
};
